import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ShoesArticle from "@/pages/article/shoes/page";
import SafetyArticle from "@/pages/article/safety/page";
import AlternativesArticle from "@/pages/article/alternatives/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-spreadsheet-shoes",
    element: <ShoesArticle />,
  },
  {
    path: "/superbuy-spreadsheet-safety",
    element: <SafetyArticle />,
  },
  {
    path: "/superbuy-spreadsheet-alternatives",
    element: <AlternativesArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;